export const userTaskListSelectors = {
	isFetching: (state) => state.userTasks.isFetching,
	isRefresh: (state) => state.userTasks.isRefresh,
	content: (state) => state.userTasks.content,
};
